// Middleware
import GuestMiddleware from '@middleware/GuestMiddleware';

export default {
    path: '/',
    name: 'home',
    meta: {
        middleware: GuestMiddleware
    },
}